import { HistoryMapService } from '@/app/maps/history/service'

const initState = {
  geofences: [],
  sidebarOpen: false,
  currentSidebar: '',
  currentSidebarTitle: '',
  historyData: null,
  loading: false,

  sideBarIndicator: false
}

const initialState = () => Object.assign({}, initState)
const historyState = initialState()

const mutations = {

  INIT_STORE(state) {
    Object.assign(state, {
      ...initState
    })
  },

  REQUEST_TOGGLE (state, s) {
    Object.assign(state, {
      loading: s
    })
  },


  SIDE_BAR_INDICATOR_TOGGLE (state, val) {
    Object.assign(state, {
      sideBarIndicator: val,
    })
  },

  TOGGLE_SIDEBAR (state, v) {
    Object.assign(state, {
      sidebarOpen: v,
      currentSidebar: ''
    })
  },

  SET_CURRENT_SIDE_BAR_COMPONENT (state, { component, title }) {
    Object.assign(state, {
      currentSidebar: component,
      currentSidebarTitle: title,
      sidebarOpen: true
    })
  },

  SET_HISTORY_DATA (state, data) {
    Object.assign(state, {
      historyData: data
    })
  },


  SET_GEOFENCES_DATA (state, data) {
    Object.assign(state, {
      geofences: data.data.data
    })
  },

}

const actions = {
  toggle_sidebar(context, { component, title }) {
    if (context.state.currentSidebar === component) context.commit('TOGGLE_SIDEBAR', false)
    else context.commit('SET_CURRENT_SIDE_BAR_COMPONENT', { component, title })
  },

  getHistory(context, form) {
    context.commit('SIDE_BAR_INDICATOR_TOGGLE', true)
    return new Promise((resolve, reject) => {
      HistoryMapService
        .getHistory(form)
        .then(res => context.commit('SET_HISTORY_DATA', res))
        .catch(reason => reject(reason))
        .finally(() => context.commit('SIDE_BAR_INDICATOR_TOGGLE', false))
    })
  },

  getDevicesOptions(context, params) {
    return new Promise((resolve, reject) => {
      HistoryMapService
        .getDevicesOptions(params)
        .then(res => resolve(res))
        .catch(reason => {})
        .finally(() => {})
    })
  },

  getAllGeofences(context, params) {
    context.commit('SIDE_BAR_INDICATOR_TOGGLE', true)

    return new Promise((resolve, reject) => {
      HistoryMapService.getGeofences(params)
        .then(res => {
          context.commit('SET_GEOFENCES_DATA', res.data)
          resolve(res.data)
        })
        .catch(reason => {})
        .finally(() => context.commit('SIDE_BAR_INDICATOR_TOGGLE', false))
    })
  }

}

export default {
  namespaced: true,
  state: historyState,
  mutations,
  actions
};
